import { RootState } from 'handlers';

export const getPaymentAccountData = ({ paymentAccount }: RootState) => paymentAccount;
